<div class="header-class">
    <h6>Lignes du bon de commande : {{ bcLineFormArray?bcLineFormArray.controls.length: ''}}</h6>
</div>
<div class="mat-table">
    <div *ngIf="form">
        <form [formGroup]="form">
            <div class="table_principal">
                <table mat-table [dataSource]="matDataSourceBCLigne" formArrayName="bcLines">
                    <caption>Liste des Bcs lignes</caption>
                    <ng-container matColumnDef="annule">
                        <th mat-header-cell *matHeaderCellDef> A </th>
                        <td mat-cell *matCellDef="let element;let index = index" class="align-cell">
                            <mat-icon class="align-icon red" *ngIf="element.get('bAnnule').value  === true">cancel</mat-icon>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="libelle">
                        <th mat-header-cell *matHeaderCellDef> Désignation </th>
                        <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index">
                            <div class="with-padding-left">
                                {{element.get('libelle').value}} 
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="qte">
                        <th mat-header-cell *matHeaderCellDef> Qte </th>
                        <td mat-cell *matCellDef="let element;let index = index"> 
                            <div class="with-padding-right">
                                {{element.get('qte').value|number:'1.4-4':'fr'}} 
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="qteLiv">
                        <th mat-header-cell *matHeaderCellDef> Qte Livré </th>
                        <td mat-cell *matCellDef="let element;let index = index"> 
                            <div class="with-padding-left">
                                {{element.get('qteLivre').value| number:'1.4-4' :'fr'}} 
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="dLivraison">
                        <th mat-header-cell *matHeaderCellDef matTooltip="Date de livraison prévisionnel"> Date livraison *</th>
                        <td mat-cell *matCellDef="let element;let index = index" class="centrer">
                            {{element.get('dLivraison').value| date: 'dd/MM/yyyy'}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="pu">
                        <th mat-header-cell *matHeaderCellDef> PU </th>
                        <td mat-cell *matCellDef="let element;let index = index" class="allign-right">
                            <div class="with-padding-right">
                                {{element.get('pu').value | currency:'EUR':'symbol':'1.2-2':'fr'}}
                            </div>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="tva">
                        <th mat-header-cell *matHeaderCellDef> TVA </th>
                        <td mat-cell *matCellDef="let element;let index = index" class="centrer">
                            {{element.get('codeTva').value}}-{{element.get('libelleTva').value}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="naCode">
                        <th mat-header-cell *matHeaderCellDef> NA </th>
                        <td mat-cell *matCellDef="let element;let index = index"
                            [matTooltip]="element.get('libelleNa').value" class="centrer">
                            {{element.get('codeNa').value}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="cg">
                        <th mat-header-cell *matHeaderCellDef> CG Charge </th>
                        <td mat-cell *matCellDef="let element;let index = index"
                            [matTooltip]="element.get('libelleCgCharge').value" class="centrer">
                            {{element.get('codeCgCharge').value}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="ca1">
                        <th mat-header-cell *matHeaderCellDef> CA1 </th>
                        <td mat-cell *matCellDef="let element;let index = index"
                            [matTooltip]="element.get('libelleCa1').value" class="centrer">
                            {{element.get('codeCa1').value}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="ca2">
                        <th mat-header-cell *matHeaderCellDef> CA2 </th>
                        <td mat-cell *matCellDef="let element;let index = index"
                            [matTooltip]="element.get('libelleCa2').value" class="centrer">
                            {{element.get('codeCa2').value}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="complement">
                        <th mat-header-cell *matHeaderCellDef> Complément </th>
                        <td mat-cell *matCellDef="let element;let index = index"
                            [matTooltip]="element.get('libelleComp').value" class="centrer">
                            {{element.get('codeComp').value }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="equipement">
                        <th mat-header-cell *matHeaderCellDef> Equipement </th>
                        <td mat-cell *matCellDef="let element;let index = index" class="centrer">
                            {{element.get('vehicule').value}} </td>
                    </ng-container>

                    <ng-container matColumnDef="codeAe">
                        <th mat-header-cell *matHeaderCellDef> Chantier </th>
                        <td mat-cell *matCellDef="let element;let index = index" class="centrer">
                            {{element.get('chantier').value}} </td>
                    </ng-container>

                    <ng-container matColumnDef="mntHt">
                        <th mat-header-cell *matHeaderCellDef> HT</th>
                        <td mat-cell *matCellDef="let element;let index = index" class="allign-right">
                            <div class="with-padding-right">
                                {{element.get('ht').value | currency:'EUR':'symbol':'1.2-2':'fr'}} 
                            </div>
                        </td>
                    </ng-container>
                    
                    <ng-container matColumnDef="bp">
                        <th mat-header-cell *matHeaderCellDef> F </th>
                        <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index"
                            class="align-cell">
                            <div *ngIf="element.get('fHasBp')">
                                <mat-icon class="align-icon green" *ngIf="element.get('fHasBp').value === 2">check_circle</mat-icon>
                                <mat-icon class="align-icon grey" *ngIf="element.get('fHasBp').value === 1">check_circle</mat-icon>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="p">
                        <th mat-header-cell *matHeaderCellDef> P </th>
                        <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index"
                            class="align-cell">
                            <div *ngIf="element.get('fProvis')">
                                <mat-icon class="align-icon green" *ngIf="element.get('fProvis').value == 2" >check_circle</mat-icon>
                                <mat-icon class="align-icon grey"  *ngIf="element.get('fProvis').value === 1">check_circle</mat-icon>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="d">
                        <th mat-header-cell *matHeaderCellDef> D </th>
                        <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index"
                            class="align-cell">
                            <div *ngIf="element.get('fDeprovis')">
                                <mat-icon class="align-icon green"  *ngIf="element.get('fDeprovis').value == 2">check_circle</mat-icon>
                                <mat-icon class="align-icon grey" *ngIf="element.get('fDeprovis').value  === 1">check_circle</mat-icon>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumnsBC ;sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumnsBC; let i = index"></tr>
                </table>
            </div>
        </form>
    </div>
</div>